import {HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';

export const ngswBypassInterceptor: HttpInterceptorFn = (httpRequest: HttpRequest<unknown>, httpHandlerFn: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (httpRequest.url.startsWith('https://${backend}') || httpRequest.url.includes('sentry.io')) {
    return httpHandlerFn(
      httpRequest.clone({
        setHeaders: {
          'ngsw-bypass': 'Yes'
        }
      }));
  }

  return httpHandlerFn(httpRequest);
}
